import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import Modal from 'modals/dialog'
import Form from 'components/form/controller'
import Message from 'components/message'
import Paragraph from 'components/typography/paragraph'
import Status from './status'
import Actions from './actions'

const BulkDownloadDocuments = ({ act, failed, progress, dismiss, salt }) => {
    const { formatMessage } = useIntl()

    return (
        <Form
            layout="vertical"
            onSubmit={act}
            key={`${salt}:bulk:download`}>
            <Modal.Body>
                <Message
                    type="info"
                    defaultDismissed
                    dismissOnUnmount
                    dismissedProps={{ className: 'spacious' }}
                    title={formatMessage({
                        id: 'documents_bulk_download_information_title',
                        defaultMessage: 'File downloads and browser permissions'
                    })}
                    message={formatMessage({
                        id: 'documents_bulk_download_information',
                        defaultMessage: 'Some browsers require your explicit permission to download multiple files at once. If you encounter issues, please check your browser settings.'
                    })}
                    name={`${salt}:bulk:download:browser-permission`} />
                {(!progress.busy && !progress.settled) && (
                    <Paragraph>
                        <FormattedMessage
                            id="documents_bulk_download_prompt"
                            defaultMessage="{count, plural, =0 {} =1 {You’re about to download 1 document.} other {You’re about to download {count} documents.}}"
                            values={{ count: progress.total }} />
                    </Paragraph>
                )}
                <Status
                    progress={progress}
                    failed={failed} />
            </Modal.Body>
            <Actions
                progress={progress}
                submissible
                dismiss={dismiss}
                submit={{
                    label: formatMessage({
                        id: 'action_proceed',
                        defaultMessage: 'Proceed'
                    })
                }} />
        </Form>
    )
}

export default BulkDownloadDocuments